import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { TreeItem, TreeView } from '@material-ui/lab';
import { memo, useEffect, useMemo, useState } from 'react';
import { rootStyle } from '../../theme';
import { LibraryScope, getDocumentLibraryRequest, openAwsDocument } from './document-library-api';
import { LibraryNode, LibraryTreeNode, buildLibraryTree } from './document-library-model';

const defaultTreeStyles = {
  root: {
    fontSize: 10,
    height: 216,
    flexGrow: 1,
    maxWidth: 300,
  },
};

function treeItems(n: LibraryTreeNode | LibraryTreeNode[], map: Map<string, LibraryTreeNode>) {
  if (Array.isArray(n)) {
    return (n as any).map((v: LibraryTreeNode) => treeItems(v, map));
  }
  const key = n.id;

  map.set(key, n);
  const nodes = n.children;
  return (
    <TreeItem
      style={{
        paddingBottom: 0,
        paddingLeft: 6
      }}
      role={'tree_item'}
      id={key}
      key={key}
      nodeId={key}
      label={n.label}
    >
      {Array.isArray(nodes) ? nodes.map((v) => treeItems(v, map)) : null}
    </TreeItem>
  );
}

type DocumentLibrarViewProps = {
  library: LibraryTreeNode[];
  categories: string[];
  id?: string;
  style?: object;
  expanded?: any[];
  title?: string;
  firstDocument?: (a: LibraryNode[]) => LibraryNode;
  onSelected?: (data: LibraryNode) => void;
};

function openDocument(doc: LibraryNode) {
  openAwsDocument(doc);
}

const map = new Map<string, LibraryTreeNode>();

export function DocumentLibraryView(props: DocumentLibrarViewProps) {
  const { style, firstDocument, library, categories } = props;
  const classes = rootStyle(defaultTreeStyles, style)();

  const [expanded, setExpanded] = useState(props.expanded || []);
  const first = firstDocument && firstDocument(library as any);
  const [selected, setSelected] = useState<string | string[]>(first?.path ? [first.path] : []);

  const onToggle = (_event, nodeIds) => {
    setExpanded(nodeIds);
  };

  const onSelect = (_: null, id: string | string[]) => {
    setSelected(id);

    if (id) {
      const node = map.get(id as string);
      if (!node?.isRoot && node?.data) {
        openDocument(node?.data);
      }
    }
  };

  useEffect(() => {
    const ids = categories || [];
    setExpanded(ids.concat(ids));
  }, categories);

  const tree = library?.length ? useMemo(() => treeItems(library, map), [library]) : null;

  return (
    tree && (
      <div style={{ marginTop: -12, maxHeight: '38vh', overflowY:'auto', maxWidth: 160, overflowX: 'hidden' }}>
        <TreeView
          className={classes.root}
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpanded={expanded}
          defaultExpandIcon={<ChevronRightIcon />}
          expanded={expanded}
          selected={selected as any}
          onNodeToggle={onToggle}
          onNodeSelect={onSelect}
          role="tree_view"
        >
          {tree}
        </TreeView>
      </div>
    )
  );
}

export const DocumentLibrary = memo((scope: LibraryScope) => {
  const [library, setLibrary] = useState<LibraryTreeNode[]>();
  const [categories, setCategories] = useState<string[]>();
  console.info('DocumentLibrary', scope);
  useEffect(() => {
    getDocumentLibraryRequest(scope).then((r) => {
      if (r.success && r.result) {
        const nodes = buildLibraryTree(r.result);
        setLibrary(nodes);
        setCategories(nodes.map((n) => n.id));
      }
    });
  }, [scope.locationCode, scope.departmentCode, scope.worksheetType, scope.workflow]);

  return library && categories && <DocumentLibraryView library={library} categories={categories} />;
});
